import type { PartialRibbonConfiguration } from "./combineConfigStores";
import { getRibbonSectionContents } from "./getRibbonSectionContents";
import { type ActionControlId } from "owa-ribbon-ids/lib/actionControlId";
import { type HelpRibbonControlId, type HelpRibbonGroupId } from "owa-ribbon-ids/lib/helpControlId";
import { type MailRibbonControlId, type MailRibbonGroupId } from "owa-ribbon-ids/lib/mailRibbonId";
import { type LabelPreferenceId } from "./labelPreferencesIds";

export const win32Config: PartialRibbonConfiguration = {
    multiline: {
        sendReceiveTab: {
            layout: [
                getRibbonSectionContents(209, [
                    562,
                ]),
                getRibbonSectionContents(117, [
                    544,
                ]),
            ],
            staticGroupIdOrdering: [
                209,
                117,
            ],
        },
        folderTab: {
            layout: [
                getRibbonSectionContents(215, [
                    768,
                    769,
                ]),
                getRibbonSectionContents(214, [
                    767,
                ]),
                getRibbonSectionContents(208, [
                    647,
                ]),
                getRibbonSectionContents(217, [
                    772,
                ]),
            ],
            staticGroupIdOrdering: [
                215,
                214,
                208,
                217,
            ],
        },
        homeTab: {
            layout: [
                getRibbonSectionContents(116, [
                    587,
                    586,
                ]),
                getRibbonSectionContents(104, [
                    531,
                    658,
                    519,
                    683,
                    684,
                    505,
                ]),
                getRibbonSectionContents(197, [
                    657,
                    535,
                    547,
                ]),
                getRibbonSectionContents(192, []),
                getRibbonSectionContents(121, [
                    556,
                    557,
                    555,
                    678,
                    553,
                    731,
                    696,
                    698,
                    686,
                    712,
                ]),
                getRibbonSectionContents(198, [
                    709,
                ]),
                getRibbonSectionContents(195, [
                    697,
                ]),
                getRibbonSectionContents(120, [
                    550,
                ]),
                getRibbonSectionContents(113, [
                    540,
                    559,
                    572,
                ]),
                getRibbonSectionContents(128, [
                    552,
                    509,
                    527,
                    616,
                    548,
                    571,
                ]),
                getRibbonSectionContents(109, [
                    585,
                    508,
                    663,
                ]),
                getRibbonSectionContents(108, [
                    502,
                ]),
                getRibbonSectionContents(118, [
                    549,
                ]),
                getRibbonSectionContents(211, [
                    7016,
                ]),
                getRibbonSectionContents(212, []),
                getRibbonSectionContents(213, []),
                getRibbonSectionContents(101, [
                    529,
                    7022,
                ]),
                getRibbonSectionContents(130, [580]),
            ],
            staticGroupIdOrdering: [
                116,
                104,
                197,
                192,
                121,
                198,
                195,
                120,
                113,
                128,
                109,
                108,
                118,
                211,
                212,
                213,
                101,
                130,
            ],
        },
        viewTab: {
            layout: [
                getRibbonSectionContents(152, [
                    643,
                ]),
                getRibbonSectionContents(153, [
                    644,
                ]),
                getRibbonSectionContents(218, [
                    774,
                ]),
                getRibbonSectionContents(210, [
                    645,
                    687,
                    688,
                    720,
                ]),
                getRibbonSectionContents(154, [
                    691,
                    647,
                    648,
                    706,
                    649,
                ]),
                getRibbonSectionContents(110, [
                    532,
                ]),
                getRibbonSectionContents(194, [
                    690,
                ]),
            ],
            staticGroupIdOrdering: [
                152,
                153,
                218,
                210,
                154,
                110,
                194,
            ],
        },
        helpTab: {
            layout: [
                getRibbonSectionContents(11001, [
                    11201,
                    11202,
                    11203,
                ]),
                getRibbonSectionContents(11002, [
                    11208,
                    11204,
                    11205,
                ]),
            ],
        },
    },
    singleline: {
        sendReceiveTab: {
            layout: [
                getRibbonSectionContents(209, [
                    562,
                ]),
                getRibbonSectionContents(117, [
                    544,
                ]),
            ],
            staticGroupIdOrdering: [
                209,
                117,
            ],
        },
        homeTab: {
            showLabelsPreference: 1,
            layout: [
                getRibbonSectionContents(116, [
                    587,
                ]),
                getRibbonSectionContents(114, [
                    519,
                    683,
                    684,
                    505,
                    540,
                    572,
                    658,
                    559,
                ]),
                getRibbonSectionContents(197, [
                    657,
                    535,
                    547,
                ]),
                getRibbonSectionContents(192, []),
                getRibbonSectionContents(121, [
                    556,
                    557,
                    555,
                    678,
                    696,
                    553,
                    698,
                    686,
                    712,
                    702,
                    703,
                ]),
                getRibbonSectionContents(198, [
                    709,
                ]),
                getRibbonSectionContents(195, [
                    697,
                ]),
                getRibbonSectionContents(128, [
                    550,
                    552,
                    509,
                    527,
                    616,
                    548,
                    571,
                ]),
                getRibbonSectionContents(109, [
                    663,
                    508,
                ]),
                getRibbonSectionContents(108, [
                    502,
                ]),
                getRibbonSectionContents(118, [
                    549,
                ]),
                getRibbonSectionContents(211, [
                    7016,
                ]),
                getRibbonSectionContents(212, []),
                getRibbonSectionContents(213, []),
                getRibbonSectionContents(101, [
                    529,
                    7022,
                ]),
                getRibbonSectionContents(130, [580]),
                getRibbonSectionContents(122, [
                    558,
                ]),
            ],
            staticGroupIdOrdering: [
                116,
                114,
                197,
                192,
                121,
                198,
                195,
                128,
                109,
                108,
                130,
                118,
                211,
                212,
                213,
                101,
            ],
            controlsInOverflow: [
                658,
                508,
                686,
                697,
                559,
                712,
                696,
                553,
                702,
                703,
            ],
        },
        viewTab: {
            layout: [
                getRibbonSectionContents(153, [
                    654,
                    687,
                    688,
                    720,
                ]),
                getRibbonSectionContents(218, [
                    774,
                ]),
                getRibbonSectionContents(154, [
                    649,
                    646,
                ]),
                getRibbonSectionContents(110, [
                    532,
                ]),
                getRibbonSectionContents(194, [
                    690,
                ]),
            ],
            staticGroupIdOrdering: [
                153,
                218,
                154,
                110,
                194,
            ],
        },
        helpTab: {
            layout: [
                getRibbonSectionContents(11001, [
                    11201,
                    11202,
                    11203,
                ]),
                getRibbonSectionContents(11002, [
                    11208,
                    11204,
                    11205,
                ]),
            ],
        },
    },
};
